import script from "./form-group.vue?vue&type=script&lang=js"
export * from "./form-group.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/form-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb0f8114"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb0f8114', __exports__)) {
    console.log('reload')
    api.reload('eb0f8114', __exports__)
  }
  
}


export default __exports__